import Node from '../node.js';
import { PARAM_TYPE, PARAM_UNITS } from '../connector.js';
import GeoUtils from '../geoUtils.js';

export default class NodeCreateSphere extends Node
{
	constructor(pParent)
	{
		super(pParent);
		
		this.addInput(PARAM_TYPE.FLOAT, 'diameter', 1.0, { units: PARAM_UNITS.METERS });
		this.addInput(PARAM_TYPE.INTEGER, 'segments', 8, { minValue: 2, maxValue: 16 });
		
		this.addOutput(PARAM_TYPE.GEOMETRY, 'geo');	
	}
	
	getType()
	{
		return 'sphere';
	}
	
	generateSubclass(scene, inputValues, outputName, computedOutputResults)
	{
		if(inputValues['diameter'] <= 0 || inputValues['diameter'] === Infinity
			|| inputValues['segments'] <= 0 || inputValues['segments'] === Infinity)
		return null;

        let pSphere = BABYLON.MeshBuilder.CreateSphere(this.getGeneratedMeshName(), { 
			diameter: inputValues['diameter'], 
			segments: inputValues['segments'], 
			sideOrientation: BABYLON.Mesh.FRONTSIDE 
		}, scene);
		//this.createAndAssignMaterial(pSphere, scene, new BABYLON.Color3(255.0/255.0, 204/255, 0));

		GeoUtils.applyBoxUVsToMeshes([pSphere]);

		this.onMeshCreated(pSphere);
		return [pSphere];
	}
}
